import { render, staticRenderFns } from "./authorityInfo.vue?vue&type=template&id=f7a308ba&scoped=true&"
import script from "./authorityInfo.vue?vue&type=script&lang=ts&"
export * from "./authorityInfo.vue?vue&type=script&lang=ts&"
import style0 from "./authorityInfo.vue?vue&type=style&index=0&id=f7a308ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a308ba",
  null
  
)

export default component.exports